import * as moment from 'moment';
import {IParsedTelegramData} from './telegram.controller';
import {
    IOperationalInputService,
    IWaterLevelTrendResponse
} from './input.service';

export default class OperationalInputDataOverviewController {
	static $inject = ['$timeout', 'operationalInputService'];



 	// date changed
	public onDateChanged($event: MouseEvent, telegramData: IParsedTelegramData) { 
		telegramData.overriddenDate = new Date(moment(telegramData.overriddenDate).hour(8).minute(0).second(0).millisecond(0).format())
      	
      	this.handleTrendDataPromise(telegramData);
	}

	// checkbox changed
	public onOverrideDateChanged($event: MouseEvent, telegramData: IParsedTelegramData) {
		if(!telegramData.overrideDate) {
			telegramData.overriddenDate = _.filter(this.cachedTelegrams, (cachedTelegram) => { 
		      	return cachedTelegram.telegramText === telegramData.telegramText
		    })[0].overriddenDate;
		}

		this.handleTrendDataPromise(telegramData);
	}

	public completedTelegrams: IParsedTelegramData[];
	public telegramsRequiringAction: IParsedTelegramData[];
	public cachedTelegrams: IParsedTelegramData[];
	public currentDate: Date;
	private isTelegramCachingCompleted: boolean = false;

	onProcessed: (callbackArgs: {
	  parsedTelegramDataCollection: IParsedTelegramData[],
	  unprocessedTelegrams: null
	}) => void;

	constructor (
		private $timeout: ng.ITimeoutService, 
		private operationalInputService: IOperationalInputService) {
		this.currentDate = new Date;
	}

	$onChanges() {
		if (
			!this.isTelegramCachingCompleted &&
			((this.completedTelegrams && this.completedTelegrams.length) ||
			(this.telegramsRequiringAction && this.telegramsRequiringAction.length))
		) {
			this.cachedTelegrams = angular.copy(this.completedTelegrams).concat(angular.copy(this.telegramsRequiringAction));
			this.isTelegramCachingCompleted = true;
		}
	}

	/**
	 * Notifies the parent component with the current processed data.
	 */
	private notifyChanges() {
	  if (this.onProcessed) {
	    this.onProcessed({
	      parsedTelegramDataCollection: this.completedTelegrams.concat(this.telegramsRequiringAction),
	      unprocessedTelegrams: null
	    });
	  }
	}

	private handleTrendDataPromise(telegramData:IParsedTelegramData) {
		const trendDataPromise = this.operationalInputService.verifyWaterTrend(
		moment(telegramData.overriddenDate).hour(8).minute(0).second(0).millisecond(0),
		telegramData.station.siteCode,
		telegramData.waterLevelData.waterLevelAtEight,
		telegramData.waterLevelData.waterLevelTrend);

  		trendDataPromise
  			.then((trendResponse: IWaterLevelTrendResponse) => {
  				const averageWaterLevel = this.operationalInputService
				        .calculateAverageWaterLevel(telegramData.waterLevelData && telegramData.waterLevelData.waterLevelAtTwenty,
				          trendResponse && trendResponse.previousWaterLevelAtEight);
				        
				telegramData.waterLevelData.averageWaterLevel = averageWaterLevel;
				telegramData.waterLevelData.previousWaterLevelAtEight = trendResponse && trendResponse.previousWaterLevelAtEight;
				telegramData.waterLevelData.validWaterTrend = trendResponse && trendResponse.valid;
				telegramData.waterLevelData.telegramDate = moment(telegramData.overriddenDate);
				telegramData.waterLevelData.previousDate = moment(telegramData.overriddenDate).subtract(1, 'day');

  			})
  			.finally(() => {
  				this.notifyChanges();
  			})
	}
}


/** WEBPACK FOOTER **
 ** ./app/operational/input/data-overview.controller.ts
 **/